import { FC } from 'react';
import { Spinner } from 'components';
import { RejectStepIcon, SuccessStepIcon } from 'components/Icon/components';
import { Modals } from 'types/store/modals';

enum RepeatTransactionType {
  send,
  approve,
}

export type ModalData = {
  [key in Modals]: {
    title: string;
    subtitle?: string;
    Icon?: string | FC;
    body1?: string;
    body2?: string;
    isCopiable?: boolean;
    repeatTransactions?: keyof typeof RepeatTransactionType;
  };
};

export const modalData: ModalData = {
  [Modals.init]: {
    title: '',
  },

  // Transaction steps modals
  [Modals.ApprovePending]: {
    title: 'STEP 1/2',
    subtitle: 'APPROVE',
    Icon: Spinner,
    body1: 'Please press "Approve" button in metamask extension',
    body2:
      'BEP-20 tokens are deployed with functionality that allows other smart contracts to move tokens. By approving the smart contracts, it now has permission to execute the peer to peer swapping behavior on your behalf. The Spend Limit permission is the total amount of tokens that are able to move when using MetaMask Swap.',
  },
  [Modals.ApproveRejected]: {
    title: 'STEP 1/2',
    subtitle: 'APPROVE',
    Icon: RejectStepIcon,
    body1: 'You rejected Approve transaction in Metamask. Press Approve again to start over or close this window.',
    body2:
      'BEP-20 tokens are deployed with functionality that allows other smart contracts to move tokens. By approving the smart contracts, it now has permission to execute the peer to peer swapping behavior on your behalf. The Spend Limit permission is the total amount of tokens that are able to move when using MetaMask Swap.',
    repeatTransactions: 'approve',
  },
  [Modals.SendPending]: {
    title: 'STEP 2/2',
    subtitle: 'SEND',
    Icon: Spinner,
    body1: 'Please press "Send" button in Metamask extension',
    body2: 'You USDT will be transferred from your wallet to the contract address',
  },
  [Modals.SendPendingSimple]: {
    title: 'STEP 2/2',
    subtitle: 'SEND',
    Icon: Spinner,
    body1: 'Please press "Confirm" button in Metamask extension',
  },
  [Modals.SendSuccess]: {
    title: 'STEP 2/2',
    subtitle: 'SEND',
    Icon: SuccessStepIcon,
    body1: 'Send',
    body2: 'It takes some time for transaction to get confirmed',
    isCopiable: true,
  },
  [Modals.SendRejected]: {
    title: 'STEP 2/2',
    subtitle: 'SEND',
    Icon: RejectStepIcon,
    body1: 'You rejected Send transaction in Metamask. Press Send again to start over or close this window.',
    repeatTransactions: 'send',
  },
};
